import axios from "axios";
import { API_URL } from "../../utils/url-constants";
import { decryptAEStoString, toastEmitter } from "../../utils/utilities";
import { clearLoggedUserReducer } from "../redux/slice/logged-user";
import { clearAccessTokenReducer } from "../redux/slice/access-token";
import { store } from "../redux/store";


// const guestTokenApi=async ()=>{
// var guestToken=""
//   let url="http://151.106.39.5:7002/auth/generateGuestToken"
//   try {
//     const response = await axios.get(url);
//     console.log("response interceptor", response);
//     if(response?.status===200){
//       guestToken=response?.data?.responseBody
//     }
//     console.log("check it guestToken variable",guestToken)
//   } catch (err) {}
// }


const axiosMain = axios.create({
  baseURL: `${API_URL.baseURL}`,
});


axiosMain.interceptors.request.use(
  async (config) => {
    const response = await axios.get(`${API_URL?.baseURL}auth/generateGuestToken`);
    localStorage.setItem("temToken", response?.data?.responseBody)
    let state = store.getState(),
      rawAccessToken = state?.accessToken?.value;
    rawAccessToken = rawAccessToken
      ? decryptAEStoString(rawAccessToken)
      : rawAccessToken;
    if (rawAccessToken) {
      config.headers.Authorization = `Bearer ${rawAccessToken}`;
      
    }
    else {
      // Set Authorization header
      config.headers.Authorization =`Bearer ${response?.data?.responseBody}`;
      // Set Security Headers
    }
    return config;

  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosMain.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status === 401 || error.code==="ERR_NETWORK") {
      store.dispatch(clearLoggedUserReducer());
      store.dispatch(clearAccessTokenReducer());
      window.location.href = process.env.PUBLIC_URL + "/";  
      return toastEmitter("error", "Session expired, Please login again!");
    }

    // return Promise.reject(error);
  }
);

export default axiosMain;
